import { AloftPrice } from '@aloft/toolkit-shared';

import { selectImprovementsCost } from '../../../../redux/features/selectors/selectImprovementsCost.ts';
import { selectSiteValue } from '../../../../redux/features/selectors/selectSiteValue.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';
import {
  DepreciateSeparatelyModalContentPriceRow,
  DepreciateSeparatelyModalContentPriceRowWrapper,
} from './DepreciateSeparatelyModalContentPriceRow.tsx';

export const DepreciateSeparatelyModalContentComponentsOfValue = ({
  activeId,
}: {
  activeId: string;
}) => {
  const improvementsCost =
    useAppSelector((state: RootState) => selectImprovementsCost(state, activeId)) ??
    AloftPrice.zero;
  const siteCost =
    useAppSelector((state: RootState) => selectSiteValue(state, activeId)) ?? AloftPrice.zero;

  const totalCost = improvementsCost.add(siteCost);
  const totalCostIsZero = totalCost.toNumericPrice() === 0;

  const improvementsCostPercentage = totalCostIsZero
    ? '0%'
    : `${improvementsCost.div(totalCost.toDollarLike()).unitAmount}%`;
  const siteCostPercentage = totalCostIsZero
    ? '0%'
    : `${siteCost.div(totalCost.toDollarLike()).unitAmount}%`;

  return (
    <DepreciateSeparatelyModalContentPriceRowWrapper>
      <DepreciateSeparatelyModalContentPriceRow
        title="Improvements"
        subtitle={improvementsCostPercentage}
        price={improvementsCost}
      />
      <DepreciateSeparatelyModalContentPriceRow
        title="Site"
        subtitle={siteCostPercentage}
        price={siteCost}
      />
    </DepreciateSeparatelyModalContentPriceRowWrapper>
  );
};
